<template>
  <div class="organization-dashboard">
    <div class="metrics-grid">
      <OrganizationalMetric
        v-for="metric in metrics"
        :key="metric.id"
        :count="metric.count"
        :value="metric.value"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import OrganizationalMetric from '@components/organizations/OrganizationalMetric/OrganizationalMetric.vue'
import { useSidebarCountStore } from '../../../account/src/store/pinia/sidebarCount'

// Initialize the sidebar count store
const sidebarCountStore = useSidebarCountStore()

// Props definition
const props = defineProps({
  title: {
    type: String,
    default: 'Organization Dashboard Section'
  }
})

// Compute metrics from store
const metrics = computed(() => [
  { id: 1, count: 'Active Employees', value: sidebarCountStore.getEmployeesCount },
  { id: 2, count: 'Active Positions', value: sidebarCountStore.getPositionsCount },
  { id: 3, count: 'Active Roles', value: sidebarCountStore.getRolesCount },
  { id: 4, count: 'Active Responsibilities', value: sidebarCountStore.getResponsibilitiesCount }
])
</script>

<style scoped>

.dashboard-title {
  color: #7C3AED;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
  position: relative;
}

.dashboard-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #7C3AED;
  border-radius: 2px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  width: 100%;
}

@media (min-width: 768px) {
  .metrics-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 767px) {
  .metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .metrics-grid {
    grid-template-columns: 1fr;
  }
}
</style>
